import React from 'react';
import { Droplets, ShieldCheck, TrendingUp, ArrowRight } from 'lucide-react';

const LSG = () => {
  const frameworks = [
    {
      icon: Droplets,
      title: "Liquidity",
      description: "Ensure sufficient cash flow for your immediate needs and emergencies while maintaining flexibility in your investment portfolio.",
      color: "#1C52A0",
      highlights: [
        "Emergency fund allocation",
        "Short-term investment options",
        "Quick access to capital"
      ]
    },
    {
      icon: ShieldCheck,
      title: "Safety",
      description: "Protect your wealth through diversification and risk management strategies tailored to your risk tolerance.",
      color: "#F49611",
      highlights: [
        "Portfolio diversification",
        "Risk assessment",
        "Capital preservation"
      ]
    },
    {
      icon: TrendingUp,
      title: "Growth",
      description: "Strategic long-term investments aimed at growing your wealth through carefully selected opportunities.",
      color: "#113262",
      highlights: [
        "Long-term wealth creation",
        "Strategic asset allocation",
        "Compound returns focus"
      ]
    }
  ];

  return (
    <div id="lsg" className="bg-gray-50 relative overflow-hidden">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">

        {/* Header with overlapping elements */}
        <div className="relative mb-16 text-center">
          <div className="inline-block relative">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4 relative pt-8">
              LSG Framework
            </h2>
          </div>
          <p className="text-gray-600 max-w-2xl mx-auto">Our proprietary approach balances immediate needs, protection, and growth objectives</p>
        </div>

        {/* Unique Hexagonal Connected Cards */}
        <div className="relative">
          {/* Connector Lines */}
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-gray-100 transform -translate-y-1/2 z-0"></div>

          {/* Three Cards */}
          <div className="flex flex-col md:flex-row justify-center items-center md:items-stretch gap-6 md:gap-10 relative z-10">
            {frameworks.map((item, index) => (
              <div key={item.title} className="w-full md:w-1/3 max-w-sm">
                {/* Card with top quarter circle */}
                <div className="relative bg-white rounded-lg shadow-lg overflow-hidden border border-gray-100 h-full flex flex-col">
                  <div className="relative h-32 flex justify-center items-center overflow-hidden">
                    {/* Icon and Title */}
                    <div className="relative z-10 text-center">
                      <div className="mx-auto mb-2 w-16 h-16 rounded-full flex items-center justify-center" style={{ backgroundColor: item.color }}>
                        <item.icon className="w-8 h-8 text-white" />
                      </div>
                      <h3 className="text-2xl font-bold" style={{ color: item.color }}>{item.title}</h3>
                    </div>
                  </div>

                  {/* Card Content */}
                  <div className="p-6 flex-grow flex flex-col">
                    {/* Description */}
                    <p className="text-gray-600 mb-8 flex-grow text-center">{item.description}</p>

                    {/* Highlights with unique styling */}
                    <div className="space-y-3">
                      {item.highlights.map((highlight, idx) => (
                        <div key={idx} className="flex items-center pl-4 py-2 relative bg-gray-50 rounded-r-lg">
                          <div className="absolute left-0 top-0 h-full w-2" style={{ backgroundColor: item.color }}></div>
                          <span className="text-gray-700 text-sm">{highlight}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-10 flex justify-end">
          <a href="/lsg" className="flex items-center text-[#1C52A0] hover:text-[#0A1E3A] transition-colors duration-300">
            <span className="font-semibold">Learn More</span>
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LSG;